import axios from "axios";
import { NO_PAYROLL_ACTIVITY, SET_ERROR, CSRS } from "../../types"
export const noPayrollActivityAction = (payload) => {
    return (dispatch) => {
        axios.get('api/active-payroll/active-clients-report', { params: payload })
            .then(
                response => {
                    dispatch({
                        type: NO_PAYROLL_ACTIVITY,
                        payload: response.data
                    });
                }).catch(e => {
                    dispatch({
                        type: SET_ERROR,
                        payload: {
                            e, error: true
                        }
                    })
                })
    }
};

export const fetchCSRSAction = () => {
    return async (dispatch) => {
        await axios.get(`api/no-active-payroll/get-csrs`).then(response => {
            dispatch({
                type: CSRS,
                payload: response.data.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};